{
  "users": {
    "pageTitle": "Users",
    "accessDenied": "You do not have permission to view this page.",
    "pageSubtitle": "Manage user accounts and their permissions",
    "table": {
      "email": "Email",
      "name": "Full name",
      "role": "Roles",
      "status": "Status",
      "createdAt": "Created",
      "actions": ""
    },
    "filters": {
      "searchPlaceholder": "Search by name or email...",
      "roleAll": "All roles",
      "roleSearchPlaceholder": "Search role...",
      "roleNoResults": "No results",
      "statusAll": "All",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "count_one": "{{count}} user",
      "count_few": "{{count}} users",
      "count_many": "{{count}} users"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "actions": {
      "addUser": "Add user",
      "edit": "Edit",
      "deactivate": "Deactivate account",
      "cancel": "Cancel",
      "save": "Save changes",
      "saving": "Saving...",
      "saved": "Saved",
      "createUser": "Create user"
    },
    "pagination": {
      "page": "Page {{page}} of {{total}} ({{count}} results)",
      "prev": "Previous page",
      "next": "Next page",
      "goToPage": "Page {{page}}"
    },
    "empty": {
      "title": "No users",
      "description": "Change search criteria or add a new user."
    },
    "create": {
      "title": "New user",
      "close": "Close",
      "fields": {
        "email": "Email",
        "emailPlaceholder": "john.smith@company.com",
        "emailInvalid": "Enter a valid email address",
        "name": "Full name",
        "namePlaceholder": "John Smith",
        "role": "Roles",
        "rolePlaceholder": "Select roles...",
        "roleSearchPlaceholder": "Search roles...",
        "roleNoResults": "No results",
        "password": "Password (min. 12 characters, must include a number or symbol)",
        "minLength": "Password must be at least 12 characters",
        "requiresNumberOrSymbol": "Password must include at least one number or symbol",
        "confirmPassword": "Confirm password",
        "confirmInvalid": "Passwords do not match"
      },
      "errors": {
        "emailTaken": "Email address is already taken"
      }
    },
    "edit": {
      "title": "Edit user",
      "close": "Close",
      "fields": {
        "email": "Email (read-only)",
        "name": "Full name",
        "role": "Roles",
        "rolePlaceholder": "Select roles...",
        "roleSearchPlaceholder": "Search roles...",
        "roleNoResults": "No results",
        "active": "Account active"
      },
      "overrides": {
        "title": "Permission overrides",
        "description": "Click to change state: Inherit -> Grant -> Revoke",
        "inherit": "Inherit",
        "grant": "Grant",
        "revoke": "Revoke",
        "sections": {
          "media_unit": "Media units",
          "attachment": "Attachments",
          "supplier": "Suppliers",
          "media_format": "Formats",
          "map": "Map",
          "cost_history": "Cost history",
          "admin": "Administration"
        }
      },
      "deactivateConfirm": "Are you sure you want to deactivate this account? The user will lose access.",
      "deactivateDialog": {
        "title": "Deactivate account",
        "description": "Are you sure you want to deactivate this account? The user will lose access to the system.",
        "cancel": "Cancel",
        "confirm": "Deactivate"
      },
      "errors": {
        "partialSave": "Basic data was saved, but permission overrides were not. Please try again."
      }
    },
    "setPassword": {
      "action": "Change password",
      "title": "Change user password",
      "fields": {
        "password": "New password (min. 12 characters, must include a number or symbol)",
        "confirmPassword": "Confirm new password",
        "confirmInvalid": "Passwords do not match",
        "minLength": "Password must be at least 12 characters",
        "requiresNumberOrSymbol": "Password must include at least one number or symbol"
      },
      "saving": "Saving...",
      "success": "Password has been changed",
      "sessionNote": "Changing the password signs the user out of their other sessions."
    }
  },
  "formatGroups": {
    "pageTitle": "System dictionaries - Format groups",
    "pageSubtitle": "Manage ad media format groups",
    "actions": {
      "addGroup": "Add group",
      "edit": "Edit",
      "deactivate": "Deactivate"
    },
    "filters": {
      "statusAll": "All",
      "statusActive": "Active",
      "statusInactive": "Inactive"
    },
    "table": {
      "code": "Code",
      "name": "Name",
      "sortOrder": "Order",
      "formatCount": "Formats",
      "status": "Status",
      "actions": ""
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "empty": {
      "title": "No format groups",
      "description": "Add your first format group."
    },
    "create": {
      "title": "Add format group",
      "close": "Close"
    },
    "edit": {
      "title": "Edit format group",
      "close": "Close"
    },
    "fields": {
      "code": "Code",
      "codePlaceholder": "e.g. large_format",
      "codeHint": "Unique technical identifier. Use underscores instead of spaces. Cannot be changed after creation.",
      "name": "Name",
      "namePlaceholder": "e.g. Large Format",
      "sortOrder": "Sort order",
      "isActive": "Group active"
    },
    "errors": {
      "codeTaken": "This code is already taken"
    },
    "deactivate": {
      "title": "Deactivate group {{name}}",
      "rolesHeader": "Roles that will lose access to this group",
      "formatsWarning_one": "{{count}} active format will lose assignment to this group",
      "formatsWarning_few": "{{count}} active formats will lose assignment to this group",
      "formatsWarning_many": "{{count}} active formats will lose assignment to this group",
      "noEffects": "Deactivation will not affect access for any role.",
      "confirm": "Confirm deactivation",
      "cancel": "Cancel"
    },
    "save": "Save",
    "saving": "Saving...",
    "saved": "Saved",
    "cancel": "Cancel"
  },
  "permissionMatrix": {
    "header": {
      "title": "Permissions",
      "infoLabel": "About this screen",
      "infoText": "Permission matrix for Grupa RW's 22 system roles.",
      "historyButton": "Change history",
      "newRoleButton": "New role"
    },
    "accessDenied": "You do not have access to manage permissions.",
    "loading": "Loading...",
    "saveBar": {
      "discard": "Discard changes",
      "save": "Save changes ({{count}})",
      "saved": "Changes saved",
      "bundleIncomplete": "These permissions must be granted or revoked together.",
      "bundleIncompleteDetailed": "{{grantedNames}} also requires the {{missingNames}} permission with the same scope."
    },
    "sidebar": {
      "searchPlaceholder": "Search roles...",
      "searchAriaLabel": "Search roles",
      "emptyState": "No roles match your search"
    },
    "roleGroups": {
      "system": "System administrators",
      "deptAdmins": "Department administrators",
      "managers": "Department managers",
      "staff": "Department staff"
    },
    "sections": {
      "media_unit": "Media units",
      "reservation": "Reservations",
      "attachment": "Attachments",
      "supplier": "Suppliers",
      "map": "Map",
      "cost": "Costs",
      "offer": "Offers",
      "admin": "Administration",
      "client": "Clients",
      "tag": "Tags",
      "media_format": "Formats",
      "cost_history": "Cost history",
      "import": "Import",
      "bulk_edit": "Bulk edit",
      "admin_boundary": "Administrative boundaries"
    },
    "permissionInfoLabel": "What this permission means",
    "permissions": {
      "media_unit": {
        "view": {
          "name": "View media units",
          "desc": "Browse the media catalog (no sensitive fields)."
        },
        "update_availability": {
          "name": "Update media unit availability",
          "desc": "Change a media unit's availability and carrier status."
        },
        "block_availability": {
          "name": "Block media unit availability",
          "desc": "Create availability windows (Free/Unavailable) for a media unit."
        },
        "create": {
          "name": "Add media units",
          "desc": "Add new media units to the catalog."
        },
        "edit": {
          "name": "Edit media units",
          "desc": "Edit existing media units."
        },
        "delete": {
          "name": "Delete media units",
          "desc": "Delete media units from the catalog."
        }
      },
      "media_units": {
        "import": {
          "name": "Import media units (legacy)",
          "desc": "Upload and import media units from an XLSX template. Legacy code kept alongside the canonical \"import\" permission for backward compatibility."
        }
      },
      "reservation": {
        "manage": {
          "name": "Manage reservations",
          "desc": "Create and modify reservations and carrier statuses."
        },
        "manage_waitlist": {
          "name": "Manage the waitlist queue",
          "desc": "Remove other users from the waitlist queue."
        },
        "force_release": {
          "name": "Force-release reservations",
          "desc": "Force-cancel another user's reservation and view all reservations."
        },
        "view": {
          "name": "View reservations",
          "desc": "Browse reservations and their statuses."
        },
        "create": {
          "name": "Create reservations",
          "desc": "Create reservation rows for availability windows."
        },
        "cancel": {
          "name": "Cancel reservations",
          "desc": "Cancel reservations you hold."
        },
        "upgrade_hard": {
          "name": "Upgrade to hard reservation",
          "desc": "Promote a soft reservation to a hard reservation."
        },
        "close_sale": {
          "name": "Close reservation sale",
          "desc": "Mark a reservation as sold."
        },
        "extend": {
          "name": "Extend reservations",
          "desc": "Extend a reservation's validity or visibility window."
        },
        "list": {
          "name": "List reservations",
          "desc": "View the reservation list and media unit audit events."
        },
        "update_dates": {
          "name": "Edit reservation dates",
          "desc": "Edit reservation start and end dates."
        }
      },
      "attachment": {
        "manage": {
          "name": "Manage attachments",
          "desc": "Add, edit, and remove media unit attachments."
        },
        "view": {
          "name": "View attachments",
          "desc": "Browse media unit attachments."
        }
      },
      "supplier": {
        "manage": {
          "name": "Manage suppliers",
          "desc": "Enter and edit supplier and contact data."
        },
        "view": {
          "name": "View suppliers",
          "desc": "Browse suppliers."
        }
      },
      "map": {
        "view": {
          "name": "View map",
          "desc": "Access the interactive map view."
        }
      },
      "cost": {
        "view": {
          "name": "View costs",
          "desc": "View media unit costs (exposure, production, install, dismantling, and additional costs). Does not include rent, which needs the separate \"View rent\" permission."
        },
        "view_rent": {
          "name": "View rent",
          "desc": "View a media unit's rent. This permission alone unlocks nothing, it also needs \"View costs\"."
        },
        "view_history": {
          "name": "View cost history",
          "desc": "Browse a media unit's cost change history."
        }
      },
      "cost_history": {
        "view": {
          "name": "View cost history (legacy)",
          "desc": "View a media unit's cost history. Legacy code kept alongside the canonical \"cost.view_history\" permission for backward compatibility."
        }
      },
      "offer": {
        "prepare": {
          "name": "Prepare offers",
          "desc": "Create and prepare offers."
        },
        "publish": {
          "name": "Publish offers",
          "desc": "Publish offer versions."
        },
        "delete": {
          "name": "Delete offers",
          "desc": "Delete offers."
        },
        "view_all": {
          "name": "View all offers",
          "desc": "View all offers of a department."
        },
        "approve_any": {
          "name": "Approve any offer",
          "desc": "Approve another user's offer on their behalf."
        },
        "create": {
          "name": "Create offers",
          "desc": "Create offer drafts."
        },
        "view": {
          "name": "View offers",
          "desc": "View offer drafts."
        },
        "update": {
          "name": "Update offers",
          "desc": "Update offer drafts."
        },
        "manage-any": {
          "name": "Manage any offer",
          "desc": "Manage offers created by other users."
        },
        "set_status_any": {
          "name": "Set any offer status",
          "desc": "Override offer status transitions for any offer."
        }
      },
      "admin": {
        "manage_users": {
          "name": "Manage users",
          "desc": "Create and manage user accounts and permission overrides."
        },
        "manage_roles": {
          "name": "Manage roles",
          "desc": "Create and manage user roles."
        },
        "manage_permissions": {
          "name": "Manage permissions",
          "desc": "Create and manage permission definitions."
        }
      },
      "client": {
        "view": {
          "name": "View clients",
          "desc": "Browse clients."
        },
        "create": {
          "name": "Add clients",
          "desc": "Add new clients."
        },
        "update": {
          "name": "Edit clients",
          "desc": "Edit client data."
        },
        "delete": {
          "name": "Delete clients",
          "desc": "Delete clients."
        }
      },
      "tag": {
        "view": {
          "name": "View tags",
          "desc": "Browse tags."
        },
        "create": {
          "name": "Add tags",
          "desc": "Create new tags."
        },
        "update": {
          "name": "Edit tags",
          "desc": "Edit tags."
        },
        "delete": {
          "name": "Delete tags",
          "desc": "Delete tags."
        }
      },
      "media_format": {
        "view": {
          "name": "View formats",
          "desc": "Browse media formats."
        },
        "create": {
          "name": "Add formats",
          "desc": "Create new media formats."
        },
        "update": {
          "name": "Edit formats",
          "desc": "Edit media formats."
        }
      },
      "import": {
        "name": "Import media units",
        "desc": "Import media units from an XLSX file."
      },
      "bulk_edit": {
        "name": "Bulk edit",
        "desc": "Bulk-edit multiple media units at once."
      },
      "admin_boundary": {
        "import": {
          "name": "Import administrative boundaries",
          "desc": "Manually trigger the administrative-boundary reference data import."
        }
      }
    },
    "roleHeader": {
      "renameSaveAriaLabel": "Save name",
      "renameCancelAriaLabel": "Cancel",
      "renameButtonAriaLabel": "Rename role",
      "immutableBadge": "Locked",
      "immutableInfoLabel": "Why is this locked",
      "immutableInfoText": "The \"Power User\" role has full system access and cannot be edited, renamed, or deactivated.",
      "inactiveTag": "inactive",
      "deactivateButton": "Deactivate role",
      "activateButton": "Activate role"
    },
    "grant": {
      "noAccess": "No access",
      "grantButton": "Grant",
      "addScope": "Add scope",
      "addScopeExhausted": "Every distinct ownership/department combination is already used by an existing scope group",
      "scopeCollisionHint": "This ownership/department combination is already used by another scope group for this permission",
      "removeScopeAriaLabel": "Remove scope — {{name}}: {{scope}}",
      "bundleNotice": "Required together with: {{names}}.",
      "mediaType": {
        "title": "Media types",
        "allOption": "All media types"
      },
      "ownership": {
        "title": "Media ownership",
        "both": "RW + Broker",
        "rwOnly": "RW only",
        "brokerOnly": "Broker only"
      },
      "department": {
        "title": "Department",
        "all": "All departments",
        "sales": "Sales dept.",
        "planners": "Planning dept.",
        "newProducts": "New Products dept."
      }
    },
    "auditPanel": {
      "title": "Change history",
      "closeAriaLabel": "Close",
      "loading": "Loading...",
      "emptyState": "No events to display",
      "unknownActor": "Unknown user",
      "actions": {
        "roleCreated": "Role created",
        "roleUpdated": "Role updated",
        "roleScopesUpdated": "Role permissions updated"
      }
    },
    "newRole": {
      "title": "New role",
      "nameLabel": "Role name",
      "namePlaceholder": "e.g. Content Dept. Manager",
      "codePreview": "Code: {{code}}",
      "codeTaken": "This code is already used by another role",
      "groupLabel": "Group",
      "cancel": "Cancel",
      "confirm": "Create role",
      "creating": "Creating..."
    },
    "confirmToggle": {
      "activateTitle": "Activate role?",
      "deactivateTitle": "Deactivate role?",
      "cancel": "Cancel",
      "activateConfirm": "Activate role",
      "deactivateConfirm": "Deactivate role",
      "activateBody": "The role \"{{name}}\" will become active again. Users assigned to this role will regain access.",
      "deactivateBody": "Deactivate the role \"{{name}}\"? Users assigned to this role will lose access."
    }
  },
  "formats": {
    "pageTitle": "System dictionaries - Media formats",
    "pageSubtitle": "Manage ad media formats",
    "actions": {
      "addFormat": "Add format",
      "edit": "Edit"
    },
    "filters": {
      "searchPlaceholder": "Search by code or label...",
      "groupAll": "All groups",
      "groupSearchPlaceholder": "Search group...",
      "groupNoResults": "No results",
      "statusAll": "All",
      "statusActive": "Active",
      "statusInactive": "Inactive"
    },
    "table": {
      "code": "Code",
      "label": "Label",
      "group": "Group",
      "sortOrder": "Order",
      "status": "Status",
      "actions": ""
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "empty": {
      "title": "No formats",
      "description": "Change filters or add a new format."
    },
    "pagination": {
      "page": "Page {{page}} of {{total}} ({{count}} results)",
      "prev": "Previous page",
      "next": "Next page",
      "goToPage": "Page {{page}}"
    },
    "create": {
      "title": "Add format",
      "close": "Close"
    },
    "edit": {
      "title": "Edit format",
      "close": "Close"
    },
    "fields": {
      "code": "Code",
      "codePlaceholder": "e.g. wf_billboard",
      "codeHint": "Unique technical identifier. Use underscores instead of spaces.",
      "label": "Label",
      "labelPlaceholder": "e.g. Large Format - Billboard",
      "group": "Group",
      "groupNone": "No group",
      "groupSearchPlaceholder": "Search group...",
      "groupNoResults": "No results",
      "sortOrder": "Sort order",
      "isActive": "Format active"
    },
    "errors": {
      "codeTaken": "This code is already taken"
    },
    "groupChange": {
      "title": "Format group change",
      "description": "Format {{label}} will be moved from group {{from}} to group {{to}}.",
      "noGroup": "No group",
      "noEffects": "No role access changes.",
      "rolesHeader": "Impact on role access",
      "gain": "will gain access",
      "lose": "will lose access",
      "confirm": "Confirm change",
      "cancel": "Cancel"
    },
    "save": "Save",
    "saving": "Saving...",
    "cancel": "Cancel",
    "count_one": "{{count}} format",
    "count_few": "{{count}} formats",
    "count_many": "{{count}} formats"
  },
  "featureFlags": {
    "pageTitle": "Feature flags",
    "pageSubtitle": "Enable or disable system features without database access",
    "permissionDenied": "You do not have permission to view this page.",
    "table": {
      "key": "Key",
      "description": "Function",
      "enabled": "Enabled",
      "toggleLabel": "Toggle {{key}} flag"
    }
  }
}
